<template>
  <div class="m-auto" style="max-width:1300px">

	<b-toast
      id="toast-check-courses"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-equis-courses"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-equis.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>


	<template v-if="!flagGestionarCursos">
    	<div class="back-step" @click="backStep">
      		<icon name="arrow-left" />{{$t('planesYPrecios.regresar')}}
   	 	</div>
    	<h6  v-show="flagMostrarVista" class="sub-title title-curso">{{$t('planesYPrecios.paso-4.titulo')}} <span>{{$t('planesYPrecios.paso-4.subTitulo', {nroCursos: this.maxSubjectsToSelect, cursos: this.maxSubjectsToSelect ==1 ? $t('reusables.course') : $t('reusables.courses')})}}</span></h6>
    </template>
	<div class="card mb-4" v-show="flagMostrarVista & !flagGestionarCursos">
      <div class="card-body p-5">
        <div class="plan-objective" v-if="!flagGestionarCursos">
          <div class="card"  >
            <img src="@/assets/img/notes.png">
				<div class="content">
					<button class="btn"  @click="getPlans(groupPersonData.planTypeId);"><icon name="edit-pencil" /></button>
					<span>{{$t('planesYPrecios.paso-4.resumen.plan.titulo')}}:</span>
					<p>{{planSelected.type.value == TipoPlanPruebaId ? $t('reusables.test-class') : planSelected.duration + " hrs"}} - $ {{planSelected.price}}</p>
				</div>
          </div>
          <div class="card"  >
			 <img v-show="goalSelected" :src="getImgObjetivoUrl(goalSelected.image)"/>
				<div class="content">
					<button class="btn" v-b-modal.modal-newObjective><icon name="edit-pencil" /></button>
					<span>{{$t('planesYPrecios.paso-4.resumen.objetivo.titulo')}}:</span>
					
					<p>{{goalSelected.name === GoalsConstants.OBJETIVO_4 ? (examSelected.id != 0 ? examSelected.name : $t('planesYPrecios.paso-2.objetivo.' + goalSelected.id)) : $t('planesYPrecios.paso-2.objetivo.' + goalSelected.id)}} 
					</p>
				</div>
          </div>
        </div>
        <div class="english-level" v-if="!flagGestionarCursos">
          <h6>{{$t('planesYPrecios.paso-4.resumen.NivelIngles')}}</h6>
          <div class="select-level">
            <button v-for="item in levels" :key="item.id" :id="'level_'+item.id"  :class="[item.id === groupPersonData.personStudent.levelId ? 'active' : null , 'gd-'+item.id]" :disabled="item.id != groupPersonData.personStudent.levelId">
				<h1>{{item.abbreviation}}<span>{{item.name}}</span></h1>
            </button>
          </div>
        </div>
      </div>
    </div> 
    <div class="card mb-4" v-show="flagMostrarVista">
        <div class="card-body p-5">
            <div class="card-title">
                <h6 class="sub-title">{{$t('planesYPrecios.paso-4.ruta.titulo')}}</h6>
                <span>{{$t('planesYPrecios.paso-4.segmentos.' + segment.id)}}</span>
            </div>
		    <ul class="route-list line">
				<li v-if="subjectsFulfilled.length > 0">
					<h3 v-if="subjectsFulfilled.length > 0">
					 	{{lang == "es" ? subjectsFulfilled [0].name: subjectsFulfilled [0].name_EN}}
						<b-link @click="goToMarketingSite(subjectsFulfilled[0].program.id)">{{$t('planesYPrecios.paso-4.ruta.info')}}</b-link>
					</h3>
					<button v-if="!courses_passed" :disabled="subjectsFulfilled.length === 1" v-b-toggle.collapse-courses-passed class="btn btn-gray">{{$t('planesYPrecios.paso-4.ruta.listado.button-cursos-superados')}}</button>
				</li>
				<li v-else>
					<h3>{{$t('planesYPrecios.paso-4.ruta.listado.elseSubjectsFulfilled')}}</h3>
					<button disabled class="btn btn-gray">{{$t('planesYPrecios.paso-4.ruta.listado.button-cursos-superados')}}</button>
				</li>

				<b-collapse class="list-collapse" id="collapse-courses-passed" v-model="courses_passed" v-show="subjectsFulfilled.length > 0">
					<li v-for="(subject, index) in subjectsFulfilled" v-show="index > 0" :key="subject.id" :id="'subjectsFulfilled_'+subject.id">
						<h3>
							{{lang == "es" ? subject.name : subject.name_EN}}
							<b-link @click="goToMarketingSite(subject.program.id)">{{$t('planesYPrecios.paso-4.ruta.info')}}</b-link>
						</h3>
						<button v-if="index == subjectsFulfilled.length-1" v-b-toggle.collapse-courses-passed class="btn btn-gray">{{$t('planesYPrecios.paso-4.ruta.showHide')}}</button>
					</li>
				</b-collapse>
				<li class="blue"  v-for="(item, index) in subjectsAvailables"  :key="item.id" :id="'subjectAvailable_'+item.id"  >
					<div class="box arrow-gris">
						<div class="d-flex align-items-center">
							<!-- <img src="@/assets/img/progress.png"> -->
						
                           <img :src="getImgObjetivoUrl(item.program.flagExamen==true?cursosJson.cursos.find(el => el.id == programacionExamen).image :cursosJson.cursos.find(el => el.id == item.programId) != null ? cursosJson.cursos.find(el => el.id == item.programId).image : 'Objetivo 2.png')" class="img-box"/>
							<div class="content">
								<h6>{{lang == "es" ? item.name : item.name_EN}}</h6>
								<p>
									{{item.program.flagExamen ? examenesJson.cursos.find(el => el.codigo == lang == "es" ? item.name.replaceAll(" ", "_") :  item.name_EN.replaceAll(" ", "_")) != null ? examenesJson.cursos.find(el => el.codigo ==  item.name.replaceAll(" ", "_")).description : "" : cursosJson.cursos.find(el => el.id == item.programId) != null ? cursosJson.cursos.find(el => el.id == item.programId).description : ""}}
									<b-link @click="goToMarketingSite(item.program.id)">{{$t('planesYPrecios.paso-4.ruta.info')}}</b-link>
								</p>
							</div>
							<b-form-checkbox class="btn-check ml-auto" :value="item.subjectLevelId" v-if="flagShowButtons" 
								 v-model="subjectsSelected"   >{{$t('planesYPrecios.paso-4.disponible.cursos.button')}}
							</b-form-checkbox>
                        </div>
				    </div>
					<button :disabled="subjectsToBeOpen.length === 1"
						v-b-toggle.collapse-next-courses 
						class="btn btn-gray"
						v-if="index == subjectsAvailables.length-1 && subjectsToBeOpen.length > 0"
					>{{next_courses ? $t('planesYPrecios.paso-4.ruta.listado.button-cursos-poximos-ocultar') : $t('planesYPrecios.paso-4.ruta.listado.button-cursos-poximos')}}</button>
				</li>
				<li v-if="subjectsToBeOpen.length > 0">
					<h3 v-if="subjectsToBeOpen.length > 0">
						{{lang == "es" ? subjectsToBeOpen[0].name : subjectsToBeOpen[0].name_EN}}
						<b-link  @click="goToMarketingSite(subjectsToBeOpen[0].program.id)">{{$t('planesYPrecios.paso-4.ruta.info')}}</b-link>
					</h3>
				</li>
				<li v-else>
					<h3>{{$t('planesYPrecios.paso-4.ruta.else.text')}}</h3>
				</li>
				<b-collapse class="list-collapse" id="collapse-next-courses" v-model="next_courses">
					<li v-for="(subject, index) in subjectsToBeOpen" v-show="index > 0" :key="subject.id" :id="'subjectsToBeOpen_'+subject.id">
						<h3>{{lang == "es" ? subject.name : subject.name_EN}}
							<b-link @click="goToMarketingSite(subject.program.id)">{{$t('planesYPrecios.paso-4.ruta.info')}}</b-link>
						</h3>
					</li>
				</b-collapse>
			</ul>
      </div>
    </div>
	<div class="footer-course mb-5" v-show="flagMostrarVista">
        <h6 v-if="subjectsSelected.length != 0">{{$t('planesYPrecios.paso-4.option')}}<span>{{labelSubjectsSelected}}</span></h6>
		<!--<b-button v-if="!isLoading && !flagGestionarCursos" variant="primary" 
		:disabled="(subjectsSelected.length == minSubjectsToSelect||subjectsSelected.length > maxSubjectsToSelect)" 
			 @click="saveSubjectsSelected();">-->
        <b-button v-if="!isLoading && !flagGestionarCursos" variant="primary" class="nose"
		:disabled="disabledSave()" 
			 @click="saveSubjectsSelected();">
			{{$t('planesYPrecios.paso-4.button')}}
		</b-button>
		<!-- <b-button v-else-if="flagGestionarCursos" variant="primary" :disabled="(subjectsSelected.length == minSubjectsToSelect||subjectsSelected.length > maxSubjectsToSelect)"> -->
		<b-button v-else-if="flagGestionarCursos && flagShowButtons" variant="primary" class="nose2" @click="updateSubjectsSelected()" :disabled="disabledSave()">
		 <template v-if="!showSpinnerSave1">{{$t('reusables.save')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light" label="Spinning"
                ></b-spinner>
		</b-button>
		<b-button v-else variant="primary" :disabled="true" v-show="flagShowButtons">
			{{$t('reusables.loading')}}
		</b-button>
    </div>
	
	<div  class="card mb-4" v-show="flagMostrarVista">
        <div class="card-body p-5">
            <div class="card-title">
                <h6 class="sub-title">{{$t('planesYPrecios.paso-4.disponible.titulo')}}</h6>
                <span>{{$t('planesYPrecios.paso-4.disponible.subTitulo')}}</span>
            </div>
			<ul class="route-list">
				
				<li v-for="(program, index) in subjectsAvailablesOthers"  :key="program.id" :id="'program_'+program.id" >
					
					<div class="box" v-if="program.subjects.length >0">
						<div class="d-flex align-items-center">
							<!-- <img src="@/assets/img/progress.png" class="img-box"> -->
							<img :src="getImgObjetivoUrl(cursosJson.cursos.find(el => el.id == program.id) != null ? cursosJson.cursos.find(el => el.id == program.id).image : 'Objetivo 2.png')" class="img-box"/>
							<div class="content d-flex align-items-center">
								<div style="max-width: 200px;width:100%">
    								<h6>{{ cursosJson.cursos.find(el => el.id == program.id) != null ? cursosJson.cursos.find(el => el.id == program.id).title : '' }}</h6>
								</div>
								<v-clamp autoresize :max-lines="3" class="pl-3" style="flex:2">
									{{cursosJson.cursos.find(el => el.id == program.id) != null ? cursosJson.cursos.find(el => el.id == program.id).description : ""}}
									{{cursosJson.cursos.find(el => el.id == program.id) != null ? cursosJson.cursos.find(el => el.id == program.id).description2 : ""}}
									<b-link
										class="ml-1"
										v-if="expanded || clamped"
										slot="after"
										slot-scope="{ toggle, expanded, clamped }"
										@click="toggle"
									>{{ expanded ? $t('planesYPrecios.paso-4.ruta.listado.cursos.leer-menos') : $t('planesYPrecios.paso-4.ruta.listado.cursos.leer-mas')}} 
									</b-link>
								</v-clamp>
							</div> 
								
							<b-form-checkbox class="btn-check pl-0" v-if="program.subjects.length === 1 && !program.subjects[0].flagAvailable && flagShowButtons" 
								:value="program.subjects[0].subjectLevelId"  v-model="subjectsSelected" 
								disabled v-b-tooltip.hover :title="$t('title.7')" >
								{{$t('planesYPrecios.paso-4.disponible.cursos.button')}}
							</b-form-checkbox>
							<b-form-checkbox class="btn-check pl-0" v-if="program.subjects.length === 1 && program.subjects[0].flagAvailable && flagShowButtons"  
								:value="program.subjects[0].subjectLevelId"
								 v-model="subjectsSelected"
								 >
								{{$t('planesYPrecios.paso-4.disponible.cursos.button')}}
							</b-form-checkbox>
						</div>
					    <div class="toggle-btn" :id="'collapse-'+index" visible  v-b-toggle="'collapse-' + index"   @click="changueTextMethod(index)" v-if="program.subjects.length > 1" >{{$t('cursos.text.1')}}
                        </div>
						 <b-collapse  :id="'collapse-'+index" visible  class="mt-2" v-if="program.subjects.length > 1" >
                            <div class="option">
							    <b-row >
	                               <b-col cols="6" class="option-select">
										<div class="option" v-for="(subject, index) in Math.ceil(program.subjects.length/2)" 
											:key="index" :id="'subject_div1_'+index" >
											<!-- {{program.subjects[index].subjectLevelId}} -->
											<a @click="showModalDetalle(program, program.subjects[index])">{{lang == "es" ? program.subjects[index].name : program.subjects[index].name_EN}}</a>
											<b-form-checkbox v-if="!program.subjects[index].flagAvailable && flagShowButtons"
												v-b-tooltip.hover :title="$t('title.7')" 
												disabled>
											</b-form-checkbox>
											<b-form-checkbox v-else-if="program.subjects[index].flagAvailable && program.subjects[index].flagCertificado  && flagShowButtons"
												v-b-tooltip.hover :title="$t('title.17')" checked="true"
												disabled>
											</b-form-checkbox>
											 
											<b-form-checkbox v-else :value="program.subjects[index].subjectLevelId" v-model="subjectsSelected" v-show="flagShowButtons">
											</b-form-checkbox>
 										</div>
									</b-col>
									<b-col cols="6" class="option-select">
										<div class="option" v-for="(subject, index) in Math.ceil(program.subjects.length/2)" 
											:key="index" :id="'subject_div2_'+(index + Math.ceil(program.subjects.length/2))" 
											v-show="(index + Math.ceil(program.subjects.length/2)) < program.subjects.length" 
										>
											<a @click="showModalDetalle(program,  program.subjects[index + Math.ceil(program.subjects.length/2)])">{{program.subjects[index + Math.ceil(program.subjects.length/2)] != null  ? lang == "es" ? program.subjects[index + Math.ceil(program.subjects.length/2)].name : program.subjects[index + Math.ceil(program.subjects.length/2)].name_EN : ""}}</a>
											<b-form-checkbox 
												v-if="program.subjects[index + Math.ceil(program.subjects.length/2)] !=null && !program.subjects[index + Math.ceil(program.subjects.length/2)].flagAvailable && flagShowButtons"
												v-b-tooltip.hover :title="$t('title.7')"
												disabled>
											</b-form-checkbox>
											<b-form-checkbox  v-else :value="program.subjects[index + Math.ceil(program.subjects.length/2)] !=  null ? program.subjects[index + Math.ceil(program.subjects.length/2)].subjectLevelId : 0" 
													v-model="subjectsSelected" v-show="flagShowButtons">
											</b-form-checkbox>
 										</div>
									</b-col>	                               
							    </b-row>
                            </div>
                        </b-collapse> 
					</div>
				</li>
				 
			</ul>
        </div>
    </div>
	
        <div class="footer-course" v-show="flagMostrarVista && groupPersonData.personStudent.id > 0">
            <h6 v-if="subjectsSelected.length != 0">{{$t('planesYPrecios.paso-4.option')}}<span>{{labelSubjectsSelected}}</span></h6>
			<!--<b-button v-if="!isLoading && !flagGestionarCursos" variant="primary" :disabled="(subjectsSelected.length == minSubjectsToSelect||subjectsSelected.length > maxSubjectsToSelect)"  @click="saveSubjectsSelected();"> -->
            <b-button v-if="!isLoading && !flagGestionarCursos && flagShowButtons" variant="primary" :disabled="disabledSave()"  @click="saveSubjectsSelected();">
				{{$t('planesYPrecios.paso-4.button')}}
			</b-button>
				<!-- <b-button v-else-if="flagGestionarCursos" variant="primary" :disabled="(subjectsSelected.length == minSubjectsToSelect||subjectsSelected.length > maxSubjectsToSelect)"> -->
	
			<b-button v-else-if="flagGestionarCursos && flagShowButtons" variant="primary"  @click="updateSubjectsSelected()" :disabled="disabledSave()">
				 <template v-if="!showSpinnerSave1">{{$t('reusables.save')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                  variant="light" label="Spinning"
                ></b-spinner>
				
			</b-button>
			<b-button v-else variant="primary" :disabled="true" v-show="flagShowButtons">
				{{$t('reusables.loading')}}
			</b-button>
        </div>
		<b-modal id="modal-newObjective" :hide-footer="true" :centered="true" ref="modal" scrollable >
			<template #modal-header>
				<img class="close" src="@/assets/img/close_red.png" @click="closeModalGoals">
             	<h6 class="sub-title">{{$t('planesYPrecios.paso-4.modal-objetivo.titulo')}}<span>{{$t('planesYPrecios.paso-4.modal-objetivo.titulo-2')}}</span></h6>
			</template>
             <div class="cards-wrap" style="max-width: 670px">
                <div class="card card_object"  v-for="item in goals" :key="item.id" :id="'goal_'+item.id"  @click="item.name === GoalsConstants.OBJETIVO_4 ? $bvModal.show('modal-courses') : null; setSelectGoal(item)" :class="item.id === goalId_selected ? 'active' : null">
		           <div class="card-body"> 
                         <img :src="getImgObjetivoUrl(item.image)"   /> 
						<p>{{item.name === GoalsConstants.OBJETIVO_4 ? (examSelected.id != 0 ? examSelected.name : $t('planesYPrecios.paso-2.objetivo.' + item.id)) : $t('planesYPrecios.paso-2.objetivo.' + item.id)}}
							<!-- <span class="material-icons-outlined ml-1" v-if="item.name === GoalsConstants.OBJETIVO_4 ?true:false" v-b-tooltip.hover.right title="Texto">info</span> -->
						</p>
                     </div>
                </div>
				<div class="content-button">
		        	<b-button variant="primary" @click="saveGoalChoice()" :disabled="!FlagSeleccionado">{{$t('planesYPrecios.paso-4.modal-objetivo.button')}}</b-button>
				</div>
            </div>
        </b-modal>
		<b-modal id="modal-newPlan" :hide-footer="true" :centered="true" size="lg" scrollable>
			<template #modal-header="{ close }">
				<img class="close" src="@/assets/img/close_red.png" @click="close()">
				<h6 class="sub-title">{{$t('planesYPrecios.paso-4.modal-plan.sub-titulo')}}<span>{{$t('planesYPrecios.paso-4.modal-plan.sub-titulo-2')}}</span></h6>
			</template>
			<div>				
				<div class="plans_container">
					<div class="d-flex align-items-center" v-for="item in plans.planes_prueba" :key="item.id" :id="'plan_'+item.id">
						<b-form-radio v-model="planId_selected" :value="item.id"/>
						<div class="card card_plan first">
							<div class="card-body">
								<div class="test-class">
									{{$t('reusables.test-class')}}
								</div>
								<div class="content-price proof">
									<h1 class="price"><i>$</i>{{item.price}}</h1>
								</div>
								<p>{{$t('reusables.test-class-description')}}
									<img src="@/assets/img/hand.png" />
								</p>
							</div>
						</div>
					</div>
					<div class="d-flex align-items-center"  v-for="(item,index) in plans.planes_regulares" :key="item.id" :id="'plan_'+item.id">
						<b-form-radio v-model="planId_selected" :value="item.id"/>
						<div class="card card_plan">
							<div class="card-header"  :id="'SelectPlanModal'+index">{{item.duration}} {{$t('planesYPrecios.paso-4.modal-plan.hours')}}</div>
							<div class="card-body">
								<div class="content-price">
									<h1 class="price"><i>$</i>{{item.price}}</h1>
									<p>{{$t('reusables.costo-por-hora', {cost: item.hourPrice})}}</p>
								</div>
								<p>{{$t('reusables.vigencia_meses', {NRO: item.meses})}}
									<icon v-if="item.tooltip" v-b-tooltip.hover.bottom :title="$t('reusables.vigencia_meses_tooltip', {NRO: item.meses})" name="info" />
								</p>
							</div>
						</div>
					</div>
					
					<div class="footer-modal">
						<h3 class="text-md">{{$t('planesYPrecios.paso-4.modal-plan.footer')}}<br> {{$t('planesYPrecios.paso-4.modal-plan.footer-2')}}</h3>
						<button class="btn-primary" @click="savePlanChoice()">{{$t('planesYPrecios.paso-4.modal-plan.button')}}</button>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="alert-modal" size="sm"
			:hide-footer="false" 
			:hide-header="false"
			:hide-body="true" 
			:centered="true" 
			:no-close-on-esc="true">
			<template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
			  <p class="text-center">{{$t('planesYPrecios.paso-4.alert-modal.text.1')}}<br>{{maxSubjectsToSelect}} {{$t('planesYPrecios.paso-4.alert-modal.text.2')}}</p>
            </template>
           
          <template #modal-footer>
			<b-button variant="primary" @click="$bvModal.hide('alert-modal')">
				{{$t('planesYPrecios.paso-4.alert-modal.button')}}
			</b-button>
          </template>
		</b-modal>

		  <b-modal id="modal-selected-subjects" :centered="true">
           <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
            </template>
			<!-- <template #modal-body> -->
				<p v-if="flagSubjectModal" class="text-center mb-0" >{{$t('modal-change-course.text-1')}} {{textCourses}}. </p>  
			   <div v-else>
				   <div v-if="numSingle>1">
					     <p  class="text-center mb-0" >{{$t('modal-change-course.text-2')}} {{textCourses}}. </p> 
					  <p  class="text-center mb-0" >{{$t('modal-change-course.text-3')}} </p> 
				   </div>
				     <div v-else>
					
					     <p  class="text-center mb-0" >{{$t('modal-change-course.text-4')}} {{textCourses}}.  </p> 
					  <p  class="text-center mb-0" >{{$t('modal-change-course.text-5')}} </p> 
				   </div>
				   

			   </div>
			<!-- </template> -->
           
          <template #modal-footer>
           
            <b-button  @click="$bvModal.hide('modal-selected-subjects')" variant="danger">
              {{$t('modals.cancel-request.button-cancel')}}
           
            </b-button>

             <b-button @click="changeCourses()" variant="primary">
                <template v-if="!showSpinnerSave">{{$t('modals.cancel-request.button-confirm-1')}}</template>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important"
                  v-else
                    variant="light" label="Spinning"
                ></b-spinner>
              </b-button>
          
          </template>
		</b-modal>


 
		<ModalCursoDetalle ref="modalCursoDetalle" :datosCurso="datosCurso" />
		<ModalCursoDetalle2 :datosExam="datosExam"/>
		<SeleccionExamen :Age="groupPersonData.personStudent.age" :exam="examSelected" @saveExamSelected="saveExamSelected" :FlagExamenSeleccionado="FlagExamenSeleccionado"/>
  </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import ModalCursoDetalle from '@/components/modals/curso-detalle'
import ModalCursoDetalle2 from '@/components/modals/curso-detalle-2'
import SeleccionExamen from '@/components/modals/seleccion'
import { TIPO_PLANES, OBJETIVOS, TIPO_PLANES_IDS, TYPE_SCHEDULED, CONSTANTES, PROGRAMS_IDS} from '@/assets/js/appConstants';  
import  cursosJson  from '@/locales/material/cursos-es.json';
import  cursosJsonEN  from '@/locales/material/cursos-en.json';
import  examenesJson  from '@/locales/material/examenes-es.json';
import  examenesJsonEN  from '@/locales/material/examenes-en.json';
import { ValidateIsPlanActive, hideSidebar } from '@/assets/js/util.js';
import * as tools from '@/assets/js/tools.js';



export default {
	components:{
		ModalCursoDetalle,
		ModalCursoDetalle2,
		SeleccionExamen
	},
	props: {
		backStep: {
			type: Function,
			default() {
				return {}
			}
		},
		nextStep: {
			type: Function,
			default() {
				return {}
			}
		},
		goals: {
			type: Array
		},
		levels: {
			type: Array
		},
		listSubject: {
			type: Array
		},
		groupData :{
			type: Object
		},
		flagGestionarCursos:{
			type: Boolean
		},

		groupPlanId : {
			type : Number
		},
		flagShowButtons: {
			type: Boolean
		}

	},
    data(){
		const lang = localStorage.getItem('lang') || 'es';
        return{
			message : '',
			lang:lang,
			showSpinnerSave1:false,
			showSpinnerSave:false,
			textCourses: '',
			numSingle : 0,
			flagSubjectModal: false,
			API_URL: process.env.VUE_APP_API_URL,
			GoalsConstants :OBJETIVOS,
			TipoPlanPruebaId :TIPO_PLANES.TIPO_PRUEBA,
			
			FlagSeleccionado:false,
			FlagExamenSeleccionado:false,
			background:true,
			active:false,
			disabledCheck:true,
			programacionExamen:0,
			//levels: [],
			
			planId_selected:0,
			//goalSelected:{},
			plans:{},
			segment:{},
			courses_passed: false,
			next_courses: false,
			
			
			subjectsAvailables:[],
			subjectsFulfilled:[],
			subjectsToBeOpen:[],
			subjectsAvailablesOthers:[],
			subjectsNames:[],
			showModalCursoTipo1:true,
			showModalCursoTipo2:true,
			
			subjectsSelected:[],
			labelSubjectsSelected:'',
			cursosJson: localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? cursosJson : cursosJsonEN,
			examenesJson:localStorage.getItem('lang') == 'es' || localStorage.getItem('lang') ==  null ? examenesJson : examenesJsonEN,
		 
			datosCurso:{}, 
			datosExam:{},
			planSelected: this.groupData.groupPerson.personStudent.planSelected,
			goalSelected: this.groupData.groupPerson.personStudent.goalSelected,
			examSelected: this.groupData.groupPerson.personStudent.examSelected,
			goalId_selected:this.groupData.groupPerson.personStudent.goalSelected.id,
			maxSubjectsToSelect:0,  
			minSubjectsToSelect:0,
			flagMostrarVista: false,
			programInfo: null,
			isLoading: false,
			TIPO_PLANES_IDS: TIPO_PLANES_IDS

        }
    },
	computed: {
		groupPersonData: {
			get() {
				return this.groupData.groupPerson;
			},
		}
		 
	},
	watch: { 
    	goalSelected: function(newVal, oldVal) {
			 
			if(newVal != null){
				 
				this.getStudyPath(this.goalSelected.id, this.examSelected != null && this.examSelected.id != 0 ? this.examSelected.id: null );
			}
		},
		groupPersonData: function(newVal, oldVal) { 

			//this.goalSelected =this.groupPersonData.personStudent.goalSelected;
			if(newVal != null && newVal.personStudent.examSelected != null && newVal.personStudent.examSelected.id 
					!= oldVal.personStudent.examSelected.id
				){
				this.getStudyPath(this.goalSelected.id, this.examSelected != null ? this.examSelected.id: null );
			}
		},
		subjectsSelected:function(newVal, oldVal){
			//validar cuantos cursos han sido seleccionados
			if(this.subjectsSelected.length > this.maxSubjectsToSelect) {
				
				this.$nextTick(function () {
					
					this.subjectsSelected = oldVal;
				})
				this.$bvModal.show("alert-modal"); 
			}

			this.labelSubjectsSelected = "";
		
			if(this.subjectsSelected.length != 0){
				
				this.labelSubjectsSelected = this.lang=="es"? this.subjectsSelected.map(e => this.subjectsNames.find(o => o.id == e).name).join(" y ") : this.subjectsSelected.map(e => this.subjectsNames.find(o => o.id == e).name_EN).join(" & ");
			
			} 

			
		}
		
	},

    mounted(){
		this.toggleTooltip();
	},
	async created() {
		 
		if(this.groupPersonData.personStudent.id > 0){
			if(!this.flagGestionarCursos){
				let planActive  = await  ValidateIsPlanActive(this.$store.state.user.personStudentId, this.$store.state.authToken); 
				
				if(!planActive){
					hideSidebar(this.$store.state.user, 3, this.$store.state.datosSidebar) 	 
					
					this.getStudyPath(this.goalSelected.id, this.examSelected != null ? this.examSelected.id: null );
					//debugger;
					this.planId_selected= this.groupPersonData.personStudent.planSelected.id;
				}else{
					this.$router.push({ name: `dashboard` }).catch(err => {}); 
				}
			}else{
				this.getStudyPath(this.goalSelected.id, this.examSelected != null ? this.examSelected.id: null );
					
			}
			
		}else{
			//cuando llego de cursos-test
			this.getStudyPath(this.goalSelected.id, this.examSelected != null ? this.examSelected.id: null );
			this.planId_selected= this.groupPersonData.personStudent.planSelected.id;
				
		}

		
    },
    methods:{
	
		changeCourses(){
			this.showSpinnerSave = true;
			
			let datos = {
				Id:this.groupPlanId,
				ListSubjectLevelIds:this.subjectsSelected ,
				UserCreated :  this.$store.state.user.email,
				FlagTypeChange: true
			}; 
            baseInstanceAxios
					.post(this.API_URL + `/Resources/Groups/ChangeSubjectLevelsByGroup`, datos)
					.then(response => {
						if (response.data != null) {
							this.message = this.$t('my-cours.course-changed-successfully');
             				this.$bvToast.show("toast-check-courses");
							if(response.data.value>0){
								let datosSidebar = {
				                 typeScheduled:0,
				                 flagPurchaseHistory:true,
				                 flagActivePlan:true,
				                 flagEdited : false,
			                      }
								datosSidebar.flagEdited = true;
                                datosSidebar.typeScheduled = TYPE_SCHEDULED.MASS_REQUEST;
                                this.$store.commit("mutateDatosSidebar",datosSidebar);	
								//this.$router.push({ path: '/horario' })
								this.$router.push({ path: '/horario/calendario/public'}).catch(err => {}); 
							}else{
								this.$emit('update-course')
							}
                            
							 this.$store.commit("mutateUpdateFlagSubject",true);
							 this.$bvModal.hide("modal-selected-subjects");
							 
						}
						this.showSpinnerSave = false;
			}).catch(function (error) {

                this.message = this.$t('my-cours.mesage-system-error');
                this.$bvToast.show("toast-equis-courses");
                this.showSpinnerSave =false;
            });
		},
		updateSubjectsSelected(){
			this.showSpinnerSave1 = true;
			
			let datos = {
				Id:this.groupPlanId,
				ListSubjectLevelIds:this.subjectsSelected 
			}; 
		
			baseInstanceAxios
					.post(this.API_URL + `/Resources/Groups/GroupPlanTeacherBySubject`, datos)
					.then(response => {
					
						if (response.data != null) {
							if(response.data.return){
							
								this.flagSubjectModal = true;
								this.textCourses = this.labelSubjectsSelected;
							
							}else{
								this.flagSubjectModal = false;
								this.numSingle = response.data.value;
								let flag_Lenguage = this.lang == "es" ? true : false;
							    let newListSubject = response.data.entity.listSubjects.map(function (elem, index) {
                                return flag_Lenguage ? elem.name : elem.name_EN;
                                }).join(", ");
								this.textCourses = response.data.message != '' ? newListSubject : '';
							}

							 this.$bvModal.show("modal-selected-subjects");
						}
						this.showSpinnerSave1 = false;
			});

		},
		disabledSave(){
			let isEqual = JSON.stringify(this.subjectsSelected) === JSON.stringify(this.listSubject);
			if(isEqual){
				return isEqual
			}else{
				return this.subjectsSelected.length == this.minSubjectsToSelect||this.subjectsSelected.length > this.maxSubjectsToSelect
			}
		},
		
		listPlansModal() {
			let b = this.plans.planes_regulares.length
			for (let index = 0; index < b; index++) {
				this.degradadoModal(index)
			}
		},
		degradadoModal(index){
			let planModal = document.getElementById("SelectPlanModal"+index);
	
			let inicioGeneral=2; //degradadoModal inicial
			let progreso= 3; //cantidad de planes con backgrund
			let progresoPaso= 80/progreso; //inicioGeneral - finGeneral=> 100%
			let diferenciaRestante= 26- inicioGeneral;
			let calculoInicio= ((index+1)*progresoPaso)-diferenciaRestante;
			let calculoFin=calculoInicio+progresoPaso;
			if(this.background){
				 
				planModal.style.background="linear-gradient(180deg, #0977c4 "+calculoInicio+"%, #1062a8 "+calculoFin+"%)"
			}
		},
		toggleTooltip(){
			if(!this.active){
				this.$root.$emit('bv::hide::tooltip')
			}
		},
		showModalDetalle(program, subject) {
				
			if(program.flagExamen == false){
				this.datosCurso = {
					programId:program.id,
					level:subject.level.abbreviation, 
					grade:subject.orden == null ? "" : subject.orden
				};
				
				this.$bvModal.show("modal-curso-detalle") 
			}else{
				this.datosExam = {
					codigo: subject.name.replaceAll(" ", "_"), 
					name:subject.name
				}
				this.$bvModal.show("modal-curso-detalle-2") 
			}

			
			//this.$refs.modalCursoDetalle.openModal();
		},
		goToMarketingSite(programId){
			//console.log("programId: " + programId)
			let url = "";
			switch (programId) {
        case PROGRAMS_IDS.GENERAL_ENGLISH:
					url = this.lang=="es" ? CONSTANTES.COURSE_GENERAL_ENGLISH_URL : CONSTANTES.COURSE_GENERAL_ENGLISH_URL_EN;
					break;
        case PROGRAMS_IDS.BUSINESS_ENGLISH:
					url = this.lang=="es" ? CONSTANTES.COURSE_BUSINESS_ENGLISH_URL: CONSTANTES.COURSE_BUSINESS_ENGLISH_URL_EN;
					break;
				case PROGRAMS_IDS.KIDS_ENGLISH:
					url = this.lang=="es" ? CONSTANTES.COURSE_KIDS_ENGLISH_URL:CONSTANTES.COURSE_KIDS_ENGLISH_URL_EN;
					break;
				case PROGRAMS_IDS.CONVERSATION_CLASSES:
					url = this.lang=="es" ? CONSTANTES.COURSE_CONVERSATION_CLASSES_URL: CONSTANTES.COURSE_CONVERSATION_CLASSES_URL_EN;
					break;
				default:
					url = this.lang=="es" ? CONSTANTES.COURSE_INTERNATIONAL_EXAMS_URL: CONSTANTES.COURSE_INTERNATIONAL_EXAMS_URL_EN;
					break;
			}
			window.open(url, '_blank');
		},
		
		addClassRed(){
			let a =this.$refs.modal.id;
			if(this.$refs.buttonRed.classList.contains('show')){
				this.$refs.buttonRed.classList.remove('show')
			
				this.$bvModal.hide(a)
			}else{
				this.$refs.buttonRed.classList.add('show')
			}
		},
		changueTextMethod(index){
			let b = document.getElementById("collapse-"+index);
		
			if(b.classList.contains('collapsed')){
				b.innerText  = this.$t('cursos.text.1');
			}else{
				b.innerText  = this.$t('cursos.text.2');
			}
		},
	
		getPlans: function(planTypeId) {
            //debugger;
			//let typeId = planTypeId == null?null:planTypeId;
			let typeId = this.planSelected.planPriceTypeId;
            baseInstanceAxios
                .get(this.API_URL + `/Sales/Plans/List?Filter=&TypeId=${typeId}&PlanPreviousTypeId=${this.groupPersonData.personStudent.planPreviousTypeId}&FlagType=true&Page=1&Size=100`)
                .then(response => {
                    var planes = response.data != null ? response.data.list : null;
                    
					if(planes != null){
						  let planes_regulares =[];
                          let planes_prueba = [];
                          let planes_empresas = []; 

                   if (planTypeId != null) {
					    planes_prueba = planes.filter(function(o) { 
							return o.type.value == TIPO_PLANES.TIPO_PRUEBA;
						});
						planes_regulares = planes.filter(function(o) {
							return (o.type.value != TIPO_PLANES.TIPO_PRUEBA && o.type.value !=TIPO_PLANES.TIPO_EMPRESAS);
						});
						planes_empresas = planes.filter(function(o) {
							return o.type.value == TIPO_PLANES.TIPO_EMPRESAS;
						});
						this.plans = {};
						this.plans.planes_prueba = planes_prueba.length != 0 ? planes_prueba: [];
						this.plans.planes_regulares = planes_regulares.length != 0 ? planes_regulares: [];
						this.plans.planes_empresas = planes_empresas.length != 0 ? planes_empresas: [];
				     }
					
						
					}
					this.$root.$emit('bv::show::modal','modal-newPlan');
                    //this.mounted = true;
                });
							
        },
		getStudyPath: function (idGoal, idExam) {
			this.$emit('update-flag', false);
			let url = this.groupPersonData.personStudent.id == 0?
						this.API_URL + `/resources/subjects/getstudypathTest?age=${this.groupPersonData.personStudent.age}&idGoal=${idGoal}&idLevel=${this.groupPersonData.personStudent.levelId}&idSubject=${idExam}&idStudent=${this.groupPersonData.personStudent.id}` :
						this.API_URL + `/resources/subjects/getstudypath?idStudent=${this.groupPersonData.personStudent.id}&idGroup=${this.groupData.id}&idGoal=${idGoal}&idSubject=${idExam}`
			
			baseInstanceAxios
			.get(url)
        	.then((response) => {
				if (response.data != null && response.data.entity != null) {
					var rptaData = response.data.entity;

					this.segment = rptaData.segment;
					this.maxSubjectsToSelect = response.data.entity.planInfo.nroCursos;
					//this.goalSelected = rptaData.goalSelected;
					//this.goalSelected.id = rptaData.goalSelected != null ? rptaData.goalSelected.id : 0;
					this.subjectsAvailables = rptaData.subjectsAvailables;
					this.subjectsFulfilled = rptaData.subjectsFulfilled;
					this.subjectsToBeOpen = rptaData.subjectsToBeOpen;
					this.subjectsAvailablesOthers= rptaData.subjectsAvailablesOthers;
					let programsSubjects = [];

					if(this.subjectsAvailablesOthers){
						for(var i = 0; i < this.subjectsAvailablesOthers.length; i++){
							programsSubjects = programsSubjects.concat(this.subjectsAvailablesOthers[i].subjects.map(subject => ({ id: subject.subjectLevelId, name: subject.name, name_EN: subject.name_EN })))
						}
					}

					this.subjectsNames = (this.subjectsAvailables.map(subject => ({ id: subject.subjectLevelId, name: subject.name, name_EN: subject.name_EN })))
								  .concat(this.subjectsFulfilled.map(subject => ({ id: subject.subjectLevelId, name: subject.name, name_EN: subject.name_EN })))
								  .concat(this.subjectsToBeOpen.map(subject => ({ id: subject.subjectLevelId, name: subject.name, name_EN: subject.name_EN })))
								  .concat(programsSubjects);
         
			 		this.groupData.flagGroup = response.data.entity.planInfo.flagGroup;
					this.flagMostrarVista = true;
					this.subjectsSelected = this.listSubject ? this.listSubject : []
					//this.planSelected = rptaData.plan;
				} else {
					//TODO: mensaje
				}
				this.$emit("update-flag", true);
			});
		},
		setSelectSubject(e){

			 
			if(this.subjectsSelected.length > this.maxSubjectsToSelect) {
				e.preventDefault();
				 
			}
			  
			/*

			var found = this.subjectsSelected.some(el => el.subjectLevelId === item.subjectLevelId);
			if(found){ //eliminar del array
				 
				this.subjectsSelected.splice(this.subjectsSelected.findIndex(el => el.subjectLevelId  === item.subjectLevelId), 1)
			
			}else{ //agregar  al array
				if(this.subjectsSelected.length < this.maxSubjectsToSelect) {
					this.subjectsSelected.push({
										"subjectLevelId": item.subjectLevelId,
										"subjectName":item.name
									});
									
				}else{
					this.$bvModal.show("alert-modal") 
				}
			}
		 
			this.labelSubjectsSelected = "";
			if(this.subjectsSelected.length != 0){
				this.labelSubjectsSelected = this.subjectsSelected.map(e => e.subjectName).join(" y ");
			
			} 
			*/
		},
		getImgObjetivoUrl(name) {
		 
			if(name != null){
				let codeObjImg =  name.replaceAll("0", "")
				return  require(`@/assets/img/${codeObjImg}`);
			}else{
				return null;
			}
		},
		setSelectGoal:function(goal){
			this.goalId_selected = goal.id; 

				if (goal.id != OBJETIVOS.OBJETIVO_4) {
                    this.FlagSeleccionado = true;
					this.FlagExamenSeleccionado = false;
					this.examSelected = {
						name: '',
						id: 0,
						programId: 0
					};
 
				} 
				else
				{
					 
					if (this.examSelected.id == 0) {
						this.FlagSeleccionado = false;
						this.examSelected = {
							name: '',
							id: 0,
							programId: 0
						};
					}
					
				}
				
				
		},
		saveGoalChoice:function(){
		
			let selected = this.goals.find(o => o.id == this.goalId_selected);

			this.goalSelected = {
					name: selected.name,
					description: selected.description,
					id: selected.id,
					image: selected.image
			}
		 
	        this.data = {
				goal: this.goalSelected,
				exam: this.examSelected
			}

		
			this.$emit('listenChildGoal', this.data);	 
			 
			this.hideModal('modal-newObjective');
	 	},
		savePlanChoice:function(){
		

			  this.plans.planes_prueba.forEach(element => {
					if (element.id == this.planId_selected) {
						this.planSelected={
                            typeId:element.typeId,
                            id:element.id,
		                    planPriceId : element.planPriceId,
							planPriceTypeId:element.planPriceTypeId,
                            type :{
                                  code : element.type.code,
                                  name : element.type.name,
                                  value : element.type.value
                            },
                            name : element.name,
                            description : element.description,
                            tooltip : element.tooltip,
                            price : element.price,
                            duration : element.duration
                           }
					}
				});
				this.plans.planes_regulares.forEach(element => {
					if (element.id == this.planId_selected) {
						this.planSelected={
                            typeId:element.typeId,
                            id:element.id,
		                    planPriceId : element.planPriceId,
							planPriceTypeId:element.planPriceTypeId,
                            type :{
                                  code : element.type.code,
                                  name : element.type.name,
                                  value : element.type.value
                            },
                            name : element.name,
                            description : element.description,
                            tooltip : element.tooltip,
                            price : element.price,
                            duration : element.duration
                        }
					}
				});

				this.data = {
					plan: this.planSelected
				}


			this.$emit('listenChildPlan', this.data);
			//TODO: aGREGAR LLAMADA AL API
			this.hideModal('modal-newPlan');
	 	},
		hideModal:function(id){
			this.$root.$emit('bv::hide::modal',id)
		},
		saveSubjectsSelected(){
			//debugger;
			this.isLoading = true;
			let exam = null; 
			if(this.examSelected.id>0)
			{
             exam = this.examSelected.id;
			}
			/* let arrSubjects= this.subjectsSelected
								.map(subject => ({ SubjectLevelsId: subject.subjectLevelId, GroupsPersonsId: this.groupPersonData.groupPersonId })); */
			//let arrSubjects= this.subjectsSelected.map(subject => ({ SubjectLevelsId: subject, GroupsPersonsId: this.groupPersonData.groupPersonId }))
			let arrSubjects= this.subjectsSelected.map(subject => ({ id: subject, name: this.subjectsNames.find(o => o.id == subject).name,name_EN: this.subjectsNames.find(o => o.id == subject).name_EN }))
			
			this.$emit('listenChild', arrSubjects);

			let datos = {
				GoalsId: this.goalSelected.id,//this.goalId_selected,
				//PlansId: this.planId_selected,
				PlanPriceId:this.planSelected.planPriceId,
				TypePlanPriceId:this.planSelected.planPriceTypeId,
				SubjectId:exam,
				GroupsPersonsId:this.groupPersonData.groupPersonId,
				GroupRegisterSubjects:arrSubjects,
				UserMail :  this.$store.state.user.email,
			}; 
			 baseInstanceAxios
					.post(this.API_URL + `/Resources/GroupRegisterSubjects/Save`, datos)
					.then(response => {
						if (response.data != null) {
							if(response.data.value === 1){
								this.nextStep();
								//cambiar por modal
								//alert("Se registró con éxito");
							}
						}
					});
		
		},
		saveExamSelected: function(dataExam){
			
				this.FlagExamenSeleccionado = true;
				this.examSelected = dataExam
				this.FlagSeleccionado = true;
				this.hideModal('modal-courses');
		},
		closeModalGoals(){
			this.goalId_selected = this.goalSelected.id;
			this.examSelected = this.groupPersonData.personStudent.examSelected;
			this.$bvModal.hide('modal-newObjective');
		}
    }
}
</script>